export const isArticoloEventoOwner = (row, user) =>
  Boolean(
    row &&
      user &&
      row.idAgente !== undefined &&
      row.idAgente !== null &&
      user.id !== undefined &&
      user.id !== null &&
      Number(row.idAgente) === Number(user.id)
  );
